/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUnpostedWire.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/unposted-wire";

export class AutogenModelUnpostedWire<RowType extends ModelRow> extends Endpoint<RowType, RowUnpostedWireFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowUnpostedWire extends ModelRow<RowUnpostedWireFields> {
	constructor(values?: Partial<RowUnpostedWireFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowUnpostedWireFields {
	account_id: string;
	ap_glid: string;
	autogen_check_code: string;
	charge_amt: number;
	charge_amt_c: string;
	charge_amt_d: Date;
	charge_amt_n: number;
	charge_amt_r: number;
	charge_code_id: string;
	check_amount: number;
	check_amount_c: string;
	check_amount_d: Date;
	check_amount_n: number;
	check_amount_r: number;
	check_code: string;
	check_number: string;
	company_id: string;
	create_other_charge: string;
	deduct_code_id: string;
	deduct_flag: string;
	deduct_status: string;
	deduct_total: number;
	descr: string;
	driver_fee_amt: number;
	driver_fee_amt_c: string;
	driver_fee_amt_d: Date;
	driver_fee_amt_n: number;
	driver_fee_amt_r: number;
	driver_id: string;
	fuel_card_id: string;
	fuel_interface_id: string;
	id: string;
	"ifuel_quikq_asset.asset_id": string;
	"ifuel_quikq_asset.asset_type": string;
	"ifuel_quikq_asset.company_id": string;
	"ifuel_quikq_asset.first_name": string;
	"ifuel_quikq_asset.last_name": string;
	"ifuel_quikq_asset.last_update_date": Date;
	"ifuel_quikq_asset.last_update_user": string;
	"ifuel_quikq_asset.master_id": string;
	"ifuel_quikq_asset.start_code": string;
	"ifuel_quikq_asset.status": string;
	ifuel_quikq_asset_id: string;
	manifest_id: string;
	"movement.additional_customer_tag": string;
	"movement.additional_global_tag": string;
	"movement.authorized": string;
	"movement.average_broker_rating": number;
	"movement.booking_no": string;
	"movement.br_details_link": string;
	"movement.br_status_link": string;
	"movement.br_track_interval": number;
	"movement.br_track_status": string;
	"movement.br_track_status_desc": string;
	"movement.br_track_vehicle_id": string;
	"movement.br_tracking_id": string;
	"movement.br_vendor": string;
	"movement.broker_avail_tract": string;
	"movement.brokerage": string;
	"movement.brokerage_status": string;
	"movement.buy_to_market_ex": string;
	"movement.carrier_contact": string;
	"movement.carrier_email": string;
	"movement.carrier_empty_from_city_id": number;
	"movement.carrier_fuel_pay_rate_id": number;
	"movement.carrier_lane_rate_id": string;
	"movement.carrier_override_carrier": string;
	"movement.carrier_override_user": string;
	"movement.carrier_phone": string;
	"movement.carrier_rate_id": number;
	"movement.carrier_scorecard_export_dt": Date;
	"movement.carrier_scorecard_exported": string;
	"movement.carrier_tractor": string;
	"movement.carrier_trailer": string;
	"movement.carrier_trailer_type": string;
	"movement.chassis": string;
	"movement.checkcall_sched_id": string;
	"movement.company_id": string;
	"movement.container": string;
	"movement.container_returned": string;
	"movement.container_status": string;
	"movement.controlling_carrier_code": string;
	"movement.dedicated_order_id": string;
	"movement.dest_stop_id": string;
	"movement.digital_booking": string;
	"movement.dispatcher_user_id": string;
	"movement.eform_rate_confirmation": string;
	"movement.empty2next_order": string;
	"movement.equipment_group_id": string;
	"movement.est_tolls": number;
	"movement.est_tolls_c": string;
	"movement.est_tolls_d": Date;
	"movement.est_tolls_n": number;
	"movement.est_tolls_r": number;
	"movement.exclude_movement": string;
	"movement.fleet_manager": string;
	"movement.freight_matching_override": string;
	"movement.fuel_distance": number;
	"movement.fuel_distance_um": string;
	"movement.fuel_tax_exempt": string;
	"movement.hubtran_approved_inv_date": Date;
	"movement.hubtran_ok2pay_date": Date;
	"movement.ic_company_to": string;
	"movement.ic_order_to": string;
	"movement.id": string;
	"movement.integrated_carrier_search": string;
	"movement.invitation_date": Date;
	"movement.invoice_recv_date": Date;
	"movement.is_container": string;
	"movement.is_dray": string;
	"movement.is_intercompany": string;
	"movement.is_local_mile": string;
	"movement.linked_id": number;
	"movement.linked_sequence": number;
	"movement.load_booking_eligible": string;
	"movement.load_booking_source": string;
	"movement.loaded": string;
	"movement.locked_user_id": string;
	"movement.ltl": string;
	"movement.ltl_staging_wrs_uid": number;
	"movement.macropoint_status": string;
	"movement.manifest_empty_distance": number;
	"movement.manifest_estimated_arrival": Date;
	"movement.manifest_estimated_depart": Date;
	"movement.manifest_hold": string;
	"movement.manifest_id": string;
	"movement.manifest_loaded_distance": number;
	"movement.manifest_reg_uid": number;
	"movement.manifest_spots_capacity": number;
	"movement.manifest_spots_consumed": number;
	"movement.manifest_weight_capacity": number;
	"movement.manifest_weight_consumed": number;
	"movement.max_buy": number;
	"movement.max_buy_c": string;
	"movement.max_buy_d": Date;
	"movement.max_buy_n": number;
	"movement.max_buy_r": number;
	"movement.max_pay_method": string;
	"movement.max_pay_units": number;
	"movement.missed_call_sent": string;
	"movement.move_distance": number;
	"movement.move_distance_um": string;
	"movement.movement_type": string;
	"movement.must_respond_by": Date;
	"movement.next_sched_call": Date;
	"movement.operational_status": string;
	"movement.operations_user": string;
	"movement.origin_stop_id": string;
	"movement.override_crny_type": string;
	"movement.override_driver2_id": number;
	"movement.override_driver2_nm": string;
	"movement.override_driver_id": number;
	"movement.override_driver_nm": string;
	"movement.override_drvr2_cell": string;
	"movement.override_drvr2_country_code": string;
	"movement.override_drvr2_email": string;
	"movement.override_drvr_cell": string;
	"movement.override_drvr_country_code": string;
	"movement.override_drvr_email": string;
	"movement.override_max_pay": number;
	"movement.override_max_pay_c": string;
	"movement.override_max_pay_d": Date;
	"movement.override_max_pay_n": number;
	"movement.override_max_pay_r": number;
	"movement.override_pay_amt": number;
	"movement.override_pay_amt_c": string;
	"movement.override_pay_amt_d": Date;
	"movement.override_pay_amt_n": number;
	"movement.override_pay_amt_r": number;
	"movement.override_pay_rate": number;
	"movement.override_paye_rate": number;
	"movement.override_payee_id": string;
	"movement.override_targetpay": number;
	"movement.override_targetpay_c": string;
	"movement.override_targetpay_d": Date;
	"movement.override_targetpay_n": number;
	"movement.override_targetpay_r": number;
	"movement.override_type": string;
	"movement.override_unit_desc": string;
	"movement.override_units": number;
	"movement.pay_distance": number;
	"movement.pay_distance_um": string;
	"movement.pending_carrier_city": string;
	"movement.pending_carrier_name": string;
	"movement.pending_carrier_nbr": string;
	"movement.pending_carrier_phone": string;
	"movement.pending_carrier_state": string;
	"movement.pending_carrier_type": string;
	"movement.pending_carrier_zip": string;
	"movement.pending_invite_conf": string;
	"movement.pending_payee_id": string;
	"movement.placard_required": string;
	"movement.preassign_sequence": number;
	"movement.priority": string;
	"movement.pro_nbr": string;
	"movement.rate_alert_basis": string;
	"movement.rate_alert_date": Date;
	"movement.rate_alert_days": number;
	"movement.rate_alert_hours": number;
	"movement.rate_alert_minutes": number;
	"movement.rate_confirm_template": number;
	"movement.rate_confirmation_sent_date": Date;
	"movement.rate_confirmation_status": string;
	"movement.rate_expiration_basis": string;
	"movement.rate_expiration_date": Date;
	"movement.rate_expiration_days": number;
	"movement.rate_expiration_hours": number;
	"movement.rate_expiration_minutes": number;
	"movement.rdy_pickup_date": Date;
	"movement.recurring_movement_id": string;
	"movement.reminder_sent": string;
	"movement.require_tracking": string;
	"movement.required_vendor": string;
	"movement.reserved": string;
	"movement.return_date": Date;
	"movement.seg_alloc_code": string;
	"movement.shipper_email": string;
	"movement.shipper_notify_frequency": string;
	"movement.shpmt_ident_type": string;
	"movement.shpmt_ident_value": string;
	"movement.ss_location_id": string;
	"movement.status": string;
	"movement.target_extra_stop_pay": number;
	"movement.target_extra_stop_pay_c": string;
	"movement.target_extra_stop_pay_d": Date;
	"movement.target_extra_stop_pay_n": number;
	"movement.target_extra_stop_pay_r": number;
	"movement.target_fuel_surcharge_pay": string;
	"movement.target_pay": number;
	"movement.target_pay_c": string;
	"movement.target_pay_d": Date;
	"movement.target_pay_method": string;
	"movement.target_pay_n": number;
	"movement.target_pay_r": number;
	"movement.target_pay_units": number;
	"movement.target_rate_data": string;
	"movement.target_rate_id": number;
	"movement.time_to_send_msg": Date;
	"movement.track_start_date": Date;
	"movement.tracking_duration_ext": number;
	"movement.tracking_notify_email": string;
	"movement.tracking_request_status": string;
	"movement.trailer_rent_pct": number;
	"movement.trip_lease": string;
	"movement.trip_mgt_recalc_datetime": Date;
	"movement.trip_mgt_tracking_id": string;
	"movement.triumphpay_exclude": string;
	"movement.trp_uid": number;
	"movement.ts_borrowing_company": string;
	"movement.ts_commodity": string;
	"movement.ts_movement_id": string;
	"movement.unlock_time": Date;
	"movement.waterfall_flood_time": Date;
	"movement.waterfall_in_progress": string;
	"movement.xfer2settle_date": Date;
	"movement.xferred2fueltax": string;
	"movement.xferred2fueltaxdt": Date;
	"movement.xmit_accepted": string;
	"movement.xmitted2driver": Date;
	"movement.zmit_trip": string;
	movement_id: string;
	ok2post: string;
	order_id: string;
	payee_id: string;
	service_charge: number;
	service_charge_c: string;
	service_charge_d: Date;
	service_charge_n: number;
	service_charge_r: number;
	source: string;
	status: string;
	"stop.actual_arrival": Date;
	"stop.actual_departure": Date;
	"stop.address": string;
	"stop.address2": string;
	"stop.appointment_status_id": string;
	"stop.appt_contact_name": string;
	"stop.appt_required": string;
	"stop.cases": number;
	"stop.city_id": number;
	"stop.city_name": string;
	"stop.company_id": string;
	"stop.confirmed": string;
	"stop.contact_email": string;
	"stop.contact_name": string;
	"stop.dist_from_prev": number;
	"stop.dist_from_prev_um": string;
	"stop.driver_load_unload": string;
	"stop.edi_code": string;
	"stop.edi_loc_code": string;
	"stop.eta": Date;
	"stop.eta_distance": number;
	"stop.eta_late": string;
	"stop.eta_oor": string;
	"stop.google_place_id": string;
	"stop.grouped_id": number;
	"stop.hub": number;
	"stop.ic_stop_id": string;
	"stop.id": string;
	"stop.inbound_status": string;
	"stop.late_eta_colorcode": string;
	"stop.late_route_status": string;
	"stop.latitude": number;
	"stop.location_id": string;
	"stop.location_name": string;
	"stop.longitude": number;
	"stop.manifest_fgp_uid": number;
	"stop.manifest_reg_uid": number;
	"stop.move_dist_from_preassign": number;
	"stop.move_dist_from_preassign_um": string;
	"stop.move_dist_from_previous": number;
	"stop.move_dist_from_previous_um": string;
	"stop.movement_id": string;
	"stop.movement_sequence": number;
	"stop.operational_status": string;
	"stop.order_id": string;
	"stop.order_sequence": number;
	"stop.orig_sched_early": Date;
	"stop.orig_sched_late": Date;
	"stop.pallets_dropped": number;
	"stop.pallets_picked_up": number;
	"stop.payment_code_reviewed": string;
	"stop.phone": string;
	"stop.planned_arrival_time": Date;
	"stop.ponum": string;
	"stop.prior_uncleared_stops": string;
	"stop.projected_arrival": Date;
	"stop.pu_override_arrive_early": Date;
	"stop.pu_override_arrive_late": Date;
	"stop.rate_dist_from_previous": number;
	"stop.rate_dist_from_previous_um": string;
	"stop.refno": string;
	"stop.requested_service": string;
	"stop.sched_arrive_early": Date;
	"stop.sched_arrive_late": Date;
	"stop.seal": string;
	"stop.service_date": Date;
	"stop.showas_address": string;
	"stop.showas_address2": string;
	"stop.showas_city_id": number;
	"stop.showas_city_name": string;
	"stop.showas_location_id": string;
	"stop.showas_location_name": string;
	"stop.showas_state": string;
	"stop.showas_zip_code": string;
	"stop.signed_for_name": string;
	"stop.state": string;
	"stop.status": string;
	"stop.stop_type": string;
	"stop.trimble_place_id": string;
	"stop.txl_uid": number;
	"stop.volume": number;
	"stop.volume_um": string;
	"stop.weight": number;
	"stop.weight_um": string;
	"stop.zip_code": string;
	"stop.zone_id": string;
	subaccount_id: string;
	trans_date_time: Date;
	user_id: string;
	wire_contract_tch: number;
	"wirecode.allow_aft_xfer_settlement": string;
	"wirecode.ap_glid": string;
	"wirecode.carrier_limit_amount": number;
	"wirecode.carrier_limit_amount_c": string;
	"wirecode.carrier_limit_amount_d": Date;
	"wirecode.carrier_limit_amount_n": number;
	"wirecode.carrier_limit_amount_r": number;
	"wirecode.carrier_limit_method": string;
	"wirecode.carrier_order_pct_limit": number;
	"wirecode.carrier_valid_move_status": string;
	"wirecode.charge_code_id": string;
	"wirecode.company_id": string;
	"wirecode.company_limit_amount": number;
	"wirecode.company_limit_amount_c": string;
	"wirecode.company_limit_amount_d": Date;
	"wirecode.company_limit_amount_n": number;
	"wirecode.company_limit_amount_r": number;
	"wirecode.company_limit_method": string;
	"wirecode.company_order_pct_limit": number;
	"wirecode.company_valid_move_status": string;
	"wirecode.contract_carrier": number;
	"wirecode.contract_driver": number;
	"wirecode.contract_no_payee": number;
	"wirecode.contract_ownerop": number;
	"wirecode.create_deduction": string;
	"wirecode.create_other_charge": string;
	"wirecode.deduct_code_id": string;
	"wirecode.deduct_in_provider_currency": string;
	"wirecode.deduct_status": string;
	"wirecode.descr": string;
	"wirecode.driver_fee_amt": number;
	"wirecode.driver_fee_amt_c": string;
	"wirecode.driver_fee_amt_d": Date;
	"wirecode.driver_fee_amt_n": number;
	"wirecode.driver_fee_amt_r": number;
	"wirecode.expense_glid": string;
	"wirecode.fuel_interface_id": string;
	"wirecode.id": string;
	"wirecode.include_fee_exp": string;
	"wirecode.is_active": string;
	"wirecode.is_atm_cash": string;
	"wirecode.issuing_user_group": string;
	"wirecode.issuing_users": string;
	"wirecode.msts_addl_fee_percent": number;
	"wirecode.msts_addl_fee_threshold": number;
	"wirecode.msts_addl_fee_threshold_c": string;
	"wirecode.msts_addl_fee_threshold_d": Date;
	"wirecode.msts_addl_fee_threshold_n": number;
	"wirecode.msts_addl_fee_threshold_r": number;
	"wirecode.no_validation": string;
	"wirecode.ownerop_limit_amount": number;
	"wirecode.ownerop_limit_amount_c": string;
	"wirecode.ownerop_limit_amount_d": Date;
	"wirecode.ownerop_limit_amount_n": number;
	"wirecode.ownerop_limit_amount_r": number;
	"wirecode.ownerop_limit_method": string;
	"wirecode.ownerop_order_pct_limit": number;
	"wirecode.ownerop_valid_move_status": string;
	"wirecode.plus_minus": string;
	"wirecode.require_order": string;
	"wirecode.service_charge": number;
	"wirecode.service_charge_c": string;
	"wirecode.service_charge_d": Date;
	"wirecode.service_charge_n": number;
	"wirecode.service_charge_r": number;
	"wirecode.subaccount_carrier": string;
	"wirecode.subaccount_driver": string;
	"wirecode.subaccount_no_payee": string;
	"wirecode.subaccount_ownerop": string;
	"wirecode.unposted_wire_status": string;
	"wirecode.wire_type": string;
	wirecode_id: string;
}

